import { render, staticRenderFns } from "./gameOverview.vue?vue&type=template&id=4b5b0740&scoped=true"
import script from "./gameOverview.vue?vue&type=script&lang=js"
export * from "./gameOverview.vue?vue&type=script&lang=js"
import style0 from "./gameOverview.vue?vue&type=style&index=0&id=4b5b0740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b0740",
  null
  
)

export default component.exports